import { RequiredAsterisk } from "components/styles";
import { Container } from "./styles";

const RequiredInformationForm = () => {
    return (
        <Container>
            <RequiredAsterisk>*</RequiredAsterisk>
            <span>Información necesaria para continuar</span>
        </Container>
    );
}

export default RequiredInformationForm;